// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-1EQ1J","title":"title-2iG4J","footer":"footer-2z3MJ"};